<div class="challenge-teams-container">
  <div class="grid">
    <div class="grid-headings">
      <p class="grid-heading">{{ 'challenges.team' | translate }}</p>
      <p class="grid-heading">{{ 'challenges.color' | translate }}</p>
      <p class="grid-heading">{{ 'challenges.users' | translate }}</p>
    </div>
    @for(team of teams; track team) {
    <div class="grid-items">
      <p class="grid-item">{{ $index + 1 }}</p>
      <app-text-input
        [(value)]="team.name"
        [disabled]="disabled"
        variant="outline"
        [width]="InputWidth.FULL"
        class="grid-item"
        (change)="onTeamNameChanged()"
        size="large"
        data-test-id="manual-team-assigment-team-name"
      ></app-text-input>
      <app-color-picker
        [(color)]="team.primaryColor"
        [disabled]="disabled"
        class="grid-item"
        data-test-id="manual-team-assigment-team-color"
      ></app-color-picker>
      <div class="grid-item">
        <p
          class="challenge-team-members"
          data-test-id="manual-team-assigment-team-size"
        >
          {{ team.members.length }}
        </p>
      </div>

      <app-form-action-button
        type="add"
        size="small"
        label="{{ 'challenges.addUsers' | translate }}"
        [icon]="false"
        [disabled]="disabled"
        (handleClick)="addUsers(team)"
        class="grid-item"
        data-test-id="manual-team-assigment-team-add-user-button"
      >
      </app-form-action-button>
      @if (teams.length > 2) {
      <app-form-action-button
        type="delete"
        label=""
        [disabled]="disabled"
        iconSize="24"
        iconXOffset="4"
        (handleClick)="deleteTeam(team)"
        class="grid-item"
        data-test-id="manual-team-assigment-team-delete-team-button"
      >
      </app-form-action-button>
      }
    </div>
    }
    <div class="grid-items">
      <p>{{ teams?.length + 1 }}</p>
      <app-form-action-button
        type="add"
        label="{{ 'challenges.addTeam' | translate }}"
        [disabled]="disabled"
        (handleClick)="addTeam()"
        data-test-id="manual-team-assigment-team-add-team-button"
      ></app-form-action-button>
    </div>

    <app-confirm-dialog
      [(isOpen)]="showConfirmDelete"
      (handleClose)="confirmDeleteClosed()"
      (handlePrimaryButton)="confirmDeleteCanceled()"
      (handleSecondaryButton)="confirmDelete()"
      [title]="deleteTeamTitle()"
      subTitle="{{ 'challenges.confirmDeleteWarning' | translate }}"
      primaryText="{{ 'challenges.keep' | translate }}"
      secondaryText="{{ 'challenges.remove' | translate }}"
      secondaryButtonType="destructive"
      data-test-id="manual-team-assigment-confirm-delete-dialog"
    ></app-confirm-dialog>
  </div>
</div>
<app-dialog testId="challenge-team-users-dialog" [(isOpen)]="showAddTeams">
  <app-challenge-users
    [(teams)]="teams"
    [(selectedTeam)]="selectedTeam"
    (confirm)="onTeamMemberChanged()"
    (cancel)="onTeamMemberCanceled()"
    data-test-id="manual-team-assigment-add-user-dialog"
  ></app-challenge-users>
</app-dialog>

<app-confirm-dialog
  [(isOpen)]="showConfirmDelete"
  (handleClose)="confirmDeleteClosed()"
  (handlePrimaryButton)="confirmDeleteCanceled()"
  (handleSecondaryButton)="confirmDelete()"
  [title]="deleteTeamTitle()"
  subTitle="{{ 'challenges.confirmDeleteWarning' | translate }}"
  primaryText="{{ 'challenges.keep' | translate }}"
  secondaryText="{{ 'challenges.remove' | translate }}"
  secondaryButtonType="destructive"
  data-test-id="manual-team-assigment-confirm-dialog"
></app-confirm-dialog>
